import styled from "styled-components";

import { TheaterTypePropsStyled as Props } from "./TheaterType.types";
import CONSTANTS from "config/constants";

const { tablet } = CONSTANTS.BREAKPOINTS;

const TheaterTypeStyled = styled.div<Props>`
  .TheaterType {
    &__type {
      color: var(--palette-light-blue-s10-l60);
      font-size: 1.6rem;
      line-height: 2.4rem;

      @media (max-width: ${tablet}px) {
        font-weight: 600;
      }
    }

    &__list {
      display: grid;
      gap: 2rem;
      grid-template-columns: repeat(auto-fit, minmax(max-content, 11.2rem));

      @media (max-width: ${tablet}px) {
        justify-content: center;
        gap: 1rem;
        grid-template-columns: repeat(auto-fit, minmax(max-content, 7.2rem));
      }
    }

    &__session {
    }
  }
`;

export default TheaterTypeStyled;
